
export class tConsultLetterModel{
    id:number;
    shopID: number;
    consultNumber:string;
    letterID: number;
    letterDate:string;
    fromAddress:string;
    toAddress:string;
    freeText1:string;
    freeText2:string;
    freeText3:string;
    freeText4:string;
    freeText5:string;
    freeText6:string;
    LastModifyUserID: string;
    LastModifyDatetime:Date;
}
export class tConsultLetterAnsModel{
    id:number;
    shopID: number;
    consultNumber:string;
    letterID: number;
    answerID:number;

    LastModifyUserID: string;
    LastModifyDatetime:Date;
}
export class tApplyTempLetterModel{
    letterID:number;
    shopID: number;
    letterName: string;
    letterNameEng:string;
   // questCatID: number;
     applyShopID:string;
   // applyStartDate: string;
    freeTextTitle1:string;
    freeTextTitle2:string;
    freeTextTitle3:string;
    freeTextTitle4:string;
    freeTextTitle5:string;
    freeTextTitle6:string;
    lastModifyUserID: string;
    inActive: string;
    color:string;
}
export class InsertApplyTempLetterModel {
    letterID:number;
    shopID: number;
    letterName: string;
    letterNameEng:string;
   // questCatID: number;
     applyShopID:string;
   // applyStartDate: string;
    freeTextTitle1:string;
    freeTextTitle2:string;
    freeTextTitle3:string;
    freeTextTitle4:string;
    freeTextTitle5:string;
    freeTextTitle6:string;
    lastModifyUserID: string;
    inActive: string;
}
export class editApplyTempLetterModel {
    letterID:number;
    shopID: number;
    letterName: string;
    letterNameEng:string;
   // questCatID: number;
     applyShopID:string;
   // applyStartDate: string;
    freeTextTitle1:string;
    freeTextTitle2:string;
    freeTextTitle3:string;
    freeTextTitle4:string;
    freeTextTitle5:string;
    freeTextTitle6:string;
    lastModifyUserID: string;
    inActive: string;
    tSelectionModel:tSelectionModel[];
}

export class tSelectionModel {
    letterID: number;
    selectionID:number;
    selectionTitle: string;
    selectionSeq: number;
    shopID: number;
    answer: tSelectionAnsModel[];
}

export class tSelectionAnsModel {
    selectionID:number;
    answerID: number;
    answerDes: string;
    answerSeq:number;
    shopID: number;
    checked:boolean;
   // ansPic: string;
   // isAnswerLock: string;
}



export class GetFieldVaildModel {
    vaild:boolean;
}
